import React, {Component} from 'react';
import AttivitaProgressGroup from './AttivitaProgressGroup'
import {normalizzaAttivitaGiorno} from '../../Helpers'
import PropTypes from 'prop-types';
class AttivitaGiornoColored extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 50,
        };
        this.writeBars = this.writeBars.bind(this);
        this.prevImg = undefined;
        this.updateCount = -1;

        this.elaboraListaAttivita = this.elaboraListaAttivita.bind(this);
        this.elaboraListaAttivita(this.props.attivitaList);
    }

    elaboraListaAttivita(attList){
        this.numRighe = 1;
        if (attList !== undefined) {
            this.LC = normalizzaAttivitaGiorno(attList);
            this.numRighe = this.LC.length;
        }
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.attivitaList !== this.props.attivitaList){
            this.elaboraListaAttivita(nextProps.attivitaList);
        }
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));

        this.writeBars();
        this.prevImg = this.props.attivitaList;
        if (this.props.onChartUpdated !== undefined){
            this.props.onChartUpdated(this.refs.bar);
        }

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentDidUpdate() {
        this.writeBars();
        if (this.prevImg !== this.props.attivitaList){
            this.updateCount = 1;
        }
        else
        {
            this.updateCount--;
        }
        this.prevImg = this.props.attivitaList;
        if (this.props.onChartUpdated !== undefined && this.updateCount >= 0){
            this.props.onChartUpdated(this.refs.bar);
        }
    }

    updateDimensions() {

        if (this.refs.chartContainer)
        {
            let winWidth = this.refs.chartContainer.offsetWidth;
            let winHeight = this.props.canvasRowHeight*this.numRighe + 18;

            if(winWidth < 50) {
                this.setState({ width: 50, height: winHeight });
            } else {
                let update_width  = winWidth;
                let update_height = winHeight;
                this.setState({ width: update_width, height: update_height });
            }
        }
    }

    scaleTimes(time){
        return Math.round((time*this.state.width)/1440);
    }

    writeBars(){

        let bottomStartSeries = this.props.canvasRowHeight*this.numRighe;
        this.barCanvasHeight = this.state.height;
        this.barTagHeight = this.state.height;

        /*
        Inizializzazione
         */
        let canvas = this.refs.bar;
        if (!canvas.getContext) return;
        var ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, this.state.width, this.state.height);

        ctx.save();
        ctx.fillStyle = 'rgba(238,238,238,0.7)';
        ctx.strokeStyle = 'rgba(238,238,238,0.7)';
        ctx.fillRect(0,0,this.state.width, bottomStartSeries);
        ctx.restore();

        if (this.LC !== undefined) {

            let LC = this.LC;

            /*
             Disegno delle barre per le attività
             */

            let numRighe = this.numRighe;
            let hRiga = this.props.canvasRowHeight;

            for (let i=0; i<numRighe; i++){
                LC[i].forEach((att) => {

                    ctx.save();
                    // ctx.strokeStyle = 'rgba(100,100,100,0.7)';
                    if (att.idCommessa !== undefined && att.durata !== 0){
                        ctx.strokeStyle = 'black';
                        ctx.fillStyle = att.idCommessa.colore;
                        //ctx.fillRect(this.scaleTimes(att.inizio), bottomStartSeries - (hRiga*i + hRiga), this.scaleTimes(att.durata), hRiga);
                        ctx.fillRect(
                            this.linearTransformX(this.scaleTimes(att.inizio)),
                            bottomStartSeries - (hRiga*i + hRiga),
                            this.scaleTimes(att.durata)*(-1),
                            hRiga);
                        // Codice commessa scritto nel rettangolo
                        ctx.strokeStyle = 'black';
                        ctx.fillStyle = 'white';
                        ctx.textAlign = 'left';
                        ctx.textBaseline = 'bottom';
                        let fontSize = (hRiga/20).toFixed(2);
                        ctx.fontFamily = 'Helvetica';
                        ctx.font = fontSize + "em sans-serif";

                        // ctx.strokeText(att.idCommessa.codice, att.inizio + 1, 70 - (hRiga*i ));
                        // ctx.fillText(att.idCommessa.codice, att.inizio + 1, 70 - (hRiga*i ));
                        //ctx.strokeRect(this.scaleTimes(att.inizio), bottomStartSeries - (hRiga*i + hRiga), this.scaleTimes(att.durata), hRiga);
                    }
                    // else
                    // {
                    //     ctx.fillStyle = 'rgb(255,255,255)'
                    //     ctx.fillRect(this.scaleTimes(att.inizio), bottomStartSeries - (hRiga*i + hRiga), this.scaleTimes(att.durata), hRiga);
                    // }
                    ctx.restore();
                })
            }
        }

        /*
         Crea la divisione in ore
         */
        ctx.save();
        for (let i=0; i<=24; i++){
            let x = Math.round(i*(this.state.width/24));

            ctx.save();
            //ctx.strokeStyle = 'rgba(100,100,100,0.7)';
            ctx.strokeStyle = 'rgba(238,238,238,0.7)';
            ctx.fillStyle = 'rgba(238,238,238,0.7)';
            ctx.beginPath();
            ctx.moveTo(this.linearTransformX(x), bottomStartSeries);
            ctx.lineTo(this.linearTransformX(x), bottomStartSeries+18);
            ctx.stroke();
            ctx.restore();

            ctx.save();
            ctx.strokeStyle = 'black';
            ctx.fillStyle = 'black';
            if (i === 0){
                ctx.textAlign = 'left';
            }
            else if (i < 24){
                ctx.textAlign = 'left';
            }

            ctx.textBaseline = 'bottom';
            ctx.font = '1em sans-serif';
            if (i<=24){
                ctx.fillText(''+ i, this.linearTransformX(x), bottomStartSeries + 18);
            }
            ctx.restore();
        }

        ctx.save();
        ctx.strokeStyle = 'black';
        ctx.beginPath();
        ctx.moveTo(this.linearTransformX(0),bottomStartSeries);
        ctx.lineTo(this.linearTransformX(this.state.width), bottomStartSeries)
        //ctx.strokeRect(0,0,this.state.width, bottomStartSeries);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }

    linearTransformX(x){
        return (this.state.width - x);
    }

    render() {
        let item = this.props.item;

        let percCompletamento = ((item.minutiTotali / item.minutiPrevisti)*100).toFixed(1);
        let tagHeight = this.state.height + "px";

        return (
            <div ref="chartContainer">
            <canvas ref="bar" style={{width:"100%", height:{tagHeight}}} width={this.state.width} height={this.state.height}>
            <AttivitaProgressGroup percCompletamento={percCompletamento}  attivitaNonCompletate={item.attivitaDaCompletare}  numAttivita={item.numAttivita} />
            </canvas>
            </div>
        )
    }
}

AttivitaGiornoColored.PropTypes = {
    item: PropTypes.object.isRequired,
    attivitaList: PropTypes.array.isRequired,
    canvasRowHeight: PropTypes.number.isRequired,
    onChartUpdated: PropTypes.func,
}

AttivitaGiornoColored.defaultProps = {
    canvasRowHeight: 30,
}
export default AttivitaGiornoColored;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaGiornoColored.js
 **/